<ng-container *ngIf="(currentUser$ | async) === null; else alreadyLoggedIn">
  <form [formGroup]="form" id="login-form">
    <div *ngIf="error" class="form-group error">
      {{ "We could not log you in. Please check your credentials and try again." | translate }}
    </div>

    <div class="form-group">
      <label for="handle"> {{ "Username" | translate }}/{{ "Email" | translate }} </label>
      <input
        id="handle"
        class="form-control"
        aria-describedby="handle-help"
        formControlName="handle"
        placeholder="example@gmail.com"
        type="text"
      />
      <small id="handle-help" class="form-text text-muted">
        {{ "We'll never share your email with anyone else." | translate }}
      </small>
    </div>

    <div class="form-group">
      <label for="password">{{ "Password" | translate }}</label>
      <div class="password-input-wrapper">
        <input
          [type]="showPassword ? 'text' : 'password'"
          id="password"
          class="form-control"
          formControlName="password"
        />
        <button
          [attr.aria-label]="showPassword ? ('Hide password' | translate) : ('Show password' | translate)"
          (click)="togglePasswordVisibility()"
          class="password-toggle"
          type="button"
        >
          <fa-icon [icon]="showPassword ? 'eye-slash' : 'eye'"></fa-icon>
        </button>
      </div>
    </div>
  </form>
</ng-container>

<ng-template #alreadyLoggedIn>
  <div class="already-logged-in">
    <p
      class="text-center"
      translate="You are already logged in or were logged in automatically from the application's backend."
    ></p>
    <div class="text-center mt-3">
      <button (click)="logout()" class="btn btn-outline-secondary">
        <fa-icon class="me-2" icon="sign-out-alt"></fa-icon>
        {{ "Log out" | translate }}
      </button>
    </div>
  </div>
</ng-template>
